import React from 'react'
import { useNavigate } from 'react-router-dom'

const Trail = () => {

    const navigate = useNavigate()

    return (
        <div className='bg-gradient-to-r from-gray-900 to-gray-800'>

            <div className='max-w-screen-2xl mx-auto py-5 md:py-6 px-4 md:px-12'>
                <div className='flex flex-col md:flex-row md:justify-between items-center gap-5'>
                    <h3 className='font-bold text-white text-xl text-center md:text-left'>
                        Curious About Our Services And<br /><span className='text-yellow-500'>Client Stories?</span> 
                    </h3>
                    <button
                        onClick={() => navigate('/protfolio')}
                        className="rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px] border-yellow-500 text-black ">
                        <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-yellow-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                        <span className="relative text-white transition duration-700 ease">Check Our Portfolio</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Trail